import styles from "./MobileCommonSlider.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'pure-react-carousel/dist/react-carousel.es.css';
import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { useNavigate } from "react-router-dom";
import MediaAssets from "assets";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const MobileCommonSlider = (props: any) => {
  const navigate = useNavigate();

  const handleRedirect = (data: any) => {
    if (props?.setToTop && (props?.toTop === false || props?.toTop === true)) {
      if (props?.toTop === true) {
        props?.setToTop(false);
      } else {
        props?.setToTop(true);
      }
    }

    navigate(`/investment-details/${data.launchName.replace(/%20|\s/g, "-")}`, {
      state: {
        projectId: data.id,
        area: data?.areaStartingFrom,
        cost: data.priceStartingFrom,
        title: data.launchName,
        pdpDisplayName:data.pdpDisplayName,
        location: data.address.city,
        description: data.shortDescription,
        isDetailed: data.isSoldOut,
        isExplore: data.isSoldOut,
        isSold: data.isSoldOut,
        dataAsObject: data,
      },
    });
  };
  return (
    <>
      <div className={styles.MobileCommonSlider}>
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={192}
          totalSlides={props?.sliderData?.length}
          isPlaying={true}
          interval={10000}
        >
          <Slider>
            {props?.sliderData &&
              props?.sliderData?.map((data: any, ind: number) => {
                // if (data?.status !== "1001") {
                //   return;
                // }
                return (
                  <Slide
                    index={ind}
                    onClick={() => {
                      handleRedirect(data);
                    }}
                    style={{ cursor: "pointer" }}
                    key={
                      ind +
                        data?.projectCoverImages?.mobileHomePage?.value?.url ||
                      data?.projectCoverImages?.homePageMedia?.value?.url
                    }
                  >
                    <div className={styles.slider_wrapper}></div>
                    <div style={{ height: "100%" }}>
                      {/* <div className={styles.icon}>
                        <LazyLoadImage
                          className={styles.iconImg}
                          src={data?.projectIcon?.value?.url}
                        />
                      </div> */}
                      <div style={{ height: "100%" }} className={styles.imgCon}>
                        <LazyLoadImage
                          src={
                            data?.projectCoverImages?.mobileHomePage?.value?.url
                              ? data?.projectCoverImages?.mobileHomePage?.value
                                  ?.url
                              : data?.projectCoverImages?.homePageMedia?.value?.url
                          }
                          className={styles.slider_img_style}
                          alt="Landing page"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: `${
                              data?.id === 56 ? "70% 50%" : data?.id === 61? "70% 50%":"center"
                            }`,
                          }}
                        />
                      </div>
                      <div className={styles.bottom_div_style}>
                        <div>
                          <h4 className={styles.bottom_heading}>
                            {data?.pdpDisplayName??data?.launchName}
                          </h4>
                          <p className={styles.content_style}>
                            {data?.shortDescription}
                          </p>
                        </div>
                        <div className={styles.explore_div_style}>
                          <LazyLoadImage
                            src={MediaAssets.subtract}
                            className={styles.subtract_img_style}
                            alt="Landing page"
                          />
                          <div className={styles.explore_heading_style}>
                            <LazyLoadImage
                              src={MediaAssets.globe}
                              style={{ marginRight: "9px" }}
                              alt="Landing page"
                            />
                            <h4
                              className={styles.explore_heading}
                              onClick={() => {
                                handleRedirect(data);
                              }}
                            >
                              Explore Now
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                );
              })}
          </Slider>
          <div className={styles.btnContainer}>
            <ButtonBack className={styles.backBtn}>
              <KeyboardArrowLeft />
            </ButtonBack>
            <ButtonNext className={styles.nxtBtn}>
              <KeyboardArrowRight />
            </ButtonNext>
          </div>
          <div className={styles.dot_wrapper}>
            {props?.sliderData &&
              props?.sliderData?.map((index: number,ind:number) => {
                return (
                  <Dot slide={index} key={ind + Number(12123123132)} className={styles.dot_style} />
                );
              })}
          </div>
        </CarouselProvider>
      </div>
    </>
  );
};

export default MobileCommonSlider;
